import { useSelector } from 'react-redux';
import { getCurrentContractId } from '@app/reducers/current-contract';
import type { RootState } from '@app/reducers';

const useCurrentContractId = () => useSelector((state: RootState) => getCurrentContractId(state));

export default useCurrentContractId;
